import React from 'react';
import { connect } from 'react-redux';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import Email from '@material-ui/icons/Email';
// core components

import Footer from '../../components/Footer/Footer.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import GridItem from '../../components/Grid/GridItem.js';
import Button from '../../components/CustomButtons/Button.js';
import Card from '../../components/Card/Card.js';
import CardBody from '../../components/Card/CardBody.js';
import CardHeader from '../../components/Card/CardHeader.js';
import CardFooter from '../../components/Card/CardFooter.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';

import styles from '../../assets/jss/material-kit-react/views/loginPage.js';

import image from '../../assets/img/bg7.jpg';
import logo from '../../assets/img/logos/PlatoPlanner-logo-white.png';
import GoogleLogin from 'react-google-login';

import { setAuthedUser } from '../../actions/authedUser';
import { handleAddUser } from '../../actions/users';
import { Link } from 'react-router-dom';
require('dotenv').config();

const bcrypt = require('bcryptjs');
const useStyles = makeStyles(styles);

function LoginPage(props) {
  const [cardAnimaton, setCardAnimation] = React.useState('cardHidden');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [isInvalidCredentials, setIsInvalidCredentials] = React.useState(false);
  setTimeout(function () {
    setCardAnimation('');
  }, 700);
  const classes = useStyles();

  const handleInputChange = (type, value) => {
    switch (type) {
      case 'email':
        setEmail(value);
        break;
      case 'password':
        setPassword(value);
        break;
      default:
        break;
    }
  };

  const handleLogIn = () => {
    // verify that username and password matches what we have on our end
    const { users } = props;
    Object.keys(users).forEach(objectId => {
      // if the email does not exist OR if the email exists and password doesn't match: send a message
      if (users[objectId].email === email) {
        if (bcrypt.compareSync(password, users[objectId].password)) {
          props.dispatch(setAuthedUser(email));
          props.history.push('/categories');
        } else {
          setIsInvalidCredentials(true);
          return;
        }
      }
      // if the email and password match: set authed user, log in successfully
      //
    });
    setIsInvalidCredentials(true);
    return;
    // set it to authed user and log in successfully to the categories page
  };

  const handleGoogleSuccess = response => {
    // verify that username and password matches what we have on our end
    const { users } = props;
    const userGoogleEmail = response.profileObj.email;
    const userGoogleName = response.profileObj.name;
    Object.keys(users).forEach(objectId => {
      // if the email does not exist OR if the email exists and password doesn't match: send a message
      if (users[objectId].email === userGoogleEmail) {
        props.dispatch(setAuthedUser(userGoogleEmail));
        props.history.push('/categories');
        return;
      }
    });
    props.dispatch(handleAddUser(userGoogleName, userGoogleEmail, ''));
    props.dispatch(setAuthedUser(userGoogleEmail));
    props.history.push('/categories');
    // set it to authed user and log in successfully to the categories page
  };

  const handleGoogleFailure = response => {
    setIsInvalidCredentials(true);
  };

  const oneFieldIsEmpty = email === '' || password === '';

  return (
    <div>
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: 'url(' + image + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
        }}
      >
        <div className={classes.container}>
          <Link to='/'>
            <img src={logo} alt='platoplanner logo' height='75' width='123' />
          </Link>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader color='primary' className={classes.cardHeader}>
                    <h2>Sign In</h2>
                    <p>Using your Google account</p>
                    <div className={classes.socialLine}>
                      <GoogleLogin
                        clientId='15837099891-d98v6f5vkron8svp8vdfgi8g5d6tb7l1.apps.googleusercontent.com'
                        buttonText=''
                        onSuccess={handleGoogleSuccess}
                        onFailure={handleGoogleFailure}
                        cookiePolicy={'single_host_origin'}
                      />
                    </div>
                  </CardHeader>
                  <p className={classes.divider}>Or old-school way</p>
                  <CardBody>
                    <CustomInput
                      labelText='Email (required)'
                      id='email'
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: 'email',
                        onChange: e =>
                          handleInputChange('email', e.target.value),
                        endAdornment: (
                          <InputAdornment position='end'>
                            <Email className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CustomInput
                      labelText='Password (required)'
                      id='pass'
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: 'password',
                        onChange: e =>
                          handleInputChange('password', e.target.value),
                        endAdornment: (
                          <InputAdornment position='end'>
                            <Icon className={classes.inputIconsColor}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                        autoComplete: 'off',
                      }}
                    />
                    {isInvalidCredentials && (
                      <h4 style={{ color: 'red' }}>
                        Your email or password is incorrect. Please try again!
                      </h4>
                    )}
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <Button
                      color='primary'
                      onClick={handleLogIn}
                      round
                      disabled={oneFieldIsEmpty}
                    >
                      Sign In
                    </Button>
                    <h4>
                      Don't have an account? Click <a href='/signup'>here</a> to
                      sign up
                    </h4>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        <Footer whiteFont />
      </div>
    </div>
  );
}

function mapStateToProps({ users, authedUser }) {
  return { users, authedUser };
}

export default connect(mapStateToProps)(LoginPage);
